export const BLACK_FRIDAY_GRADIENT =
  "linear-gradient(110deg, #E50914 0%, #E50914 38%, #FF4500 44%, #FFB703 48%, #FFFFFF 50%, #FFB703 52%, #FF4500 56%, #E50914 62%, #E50914 100%)"

export const blackFridayAnimationKeyframes = {
  "@keyframes bfFlashWave": {
    "0%": {
      backgroundPosition: "100% 0"
    },
    "60%": {
      backgroundPosition: "0% 0"
    },
    "100%": {
      backgroundPosition: "0% 0"
    }
  },
  "@keyframes bfTextGlow": {
    "0%": {
      filter:
        "drop-shadow(0 0 2px rgba(229, 9, 20, 0.45)) drop-shadow(0 0 6px rgba(255, 69, 0, 0.25))"
    },
    "30%": {
      filter:
        "drop-shadow(0 0 8px rgba(229, 9, 20, 0.9)) drop-shadow(0 0 16px rgba(255, 120, 0, 0.65))"
    },
    "60%": {
      filter:
        "drop-shadow(0 0 2px rgba(229, 9, 20, 0.45)) drop-shadow(0 0 6px rgba(255, 69, 0, 0.25))"
    },
    "100%": {
      filter:
        "drop-shadow(0 0 2px rgba(229, 9, 20, 0.45)) drop-shadow(0 0 6px rgba(255, 69, 0, 0.25))"
    }
  }
}

export const blackFridayTextSx = {
  display: "inline-block",
  fontWeight: "800 !important",
  letterSpacing: "0.03em",
  background: BLACK_FRIDAY_GRADIENT,
  backgroundSize: "350% 100%",
  backgroundRepeat: "no-repeat",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  animation:
    "bfFlashWave 2.8s cubic-bezier(0.25, 0.1, 0.25, 1) infinite, bfTextGlow 2.8s ease-in-out infinite",
  ...blackFridayAnimationKeyframes
}

